module.exports = __webpack_public_path__ + "static/P2101464-2d5eca4c490da3c3fc166d04bd5652eb.jpg";